import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { AuthLayout } from "../../layouts/Auth";
import { ArrowLeft } from "lucide-react";
import { Mail } from "lucide-react";
import { Button } from "~/atoms/button";

export const EmailSent = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <AuthLayout
      icon={
        <div className="bg-success/10 text-success flex size-11 items-center justify-center rounded-full">
          <Mail />
        </div>
      }
      title={t(($) => $.password.email.check)}
      description={t(($) => $.password.email.description)}
    >
      <Button
        className="max-w-fit"
        variant="default"
        onClick={() => navigate("/login")}
      >
        <ArrowLeft className="size-5" />
        {t(($) => $.password.backToLogin)}
      </Button>
    </AuthLayout>
  );
};
